module.exports = __webpack_public_path__ + "img/loginPasswordRed.a730cc7e.png";